import { MaskLine } from "./Reveal";

export const PageHeader = ({ overline, title, italic, subtitle, image, imagePosition = "center" }) => (
  <section className="relative pt-40 pb-20 overflow-hidden" data-testid="page-header">
    <div className="noise" />
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          {overline && <p className="overline mb-6" style={{ color: "var(--gold)" }}>{overline}</p>}
          <h1 className="font-display leading-[1.02] tracking-tight text-5xl md:text-6xl lg:text-7xl" style={{ color: "var(--navy)" }}>
            <MaskLine>{title}</MaskLine>
            {italic && <MaskLine delay={0.12} className="italic" >{italic}</MaskLine>}
          </h1>
          {subtitle && (
            <p className="font-body font-light text-lg md:text-xl mt-8 max-w-xl leading-relaxed" style={{ color: "var(--muted)" }}>
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl border" style={{ borderColor: "rgba(212,175,55,0.3)" }}>
              <img src={image} alt={title} className="w-full h-[300px] lg:h-[360px] object-cover" style={{ objectPosition: imagePosition }} />
            </div>
          </div>
        )}
      </div>
    </div>
  </section>
);
